import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Activity, RefreshCw } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-brand-900 text-white relative overflow-hidden" data-id="element-115">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-116">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand-400 rounded-full blur-[100px]" data-id="element-117" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-300 rounded-full blur-[100px]" data-id="element-118" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-800 border-2 border-brand-400 mb-6 shadow-[0_0_30px_rgba(45,212,191,0.3)]" data-id="element-121">
            <Zap className="w-8 h-8 text-brand-300" data-id="element-122" />
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-6" data-id="element-123">
            El Secreto está en el{' '}
            <span className="text-brand-300" data-id="element-124">
              Reset Miofascial de "Cero Pasos"
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg text-brand-50 leading-relaxed" data-id="element-126">
            <p data-id="element-127">
              La clave no es tratar el pie después de que ya te duele, sino{' '}
              <strong className="text-white" data-id="element-128">
                preparar el tejido conectivo mientras aún estás en la cama.
              </strong>
            </p>
            <p data-id="element-129">
              Al liberar la tensión de la cadena posterior antes de que reciba
              el peso de tu cuerpo, eliminamos la causa del desgarro matutino.
            </p>
            <div className="bg-brand-800/50 border border-brand-700 p-6 rounded-2xl mt-8" data-id="element-130">
              <p className="font-medium text-brand-100 italic" data-id="element-131">
                "Permitimos que la fascia sane de forma natural mientras tú
                sigues con tu vida, sin dolor desde el primer paso."
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="grid gap-4" data-id="element-132">
            {[{
            icon: Activity,
            title: 'Sin dolor al despertar',
            desc: 'Prepara el tejido antes del impacto.'
          }, {
            icon: RefreshCw,
            title: 'Sanación natural',
            desc: 'Detiene los micro-desgarros diarios.'
          }, {
            icon: Zap,
            title: 'Solo 2 minutos',
            desc: 'Fácil de integrar en tu rutina matutina.'
          }].map((feature, idx) => <div key={idx} className="flex items-center gap-4 bg-brand-800/40 p-4 rounded-xl border border-brand-700/50 backdrop-blur-sm" data-id="element-133">
                <div className="bg-brand-700 p-3 rounded-lg text-brand-300" data-id="element-134">
                  <feature.icon className="w-6 h-6" data-id="element-135" />
                </div>
                <div data-id="element-136">
                  <h4 className="font-bold text-white" data-id="element-137">{feature.title}</h4>
                  <p className="text-brand-200 text-sm" data-id="element-138">{feature.desc}</p>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}